<mat-form-field appearance="outline" class="w-20 !-mb-[1.25em]">
    <mat-select [formControl]="form.controls.isHandedOver" panelWidth="w-full">
        @for (
            handedOverOption of handedOverDropdownOptions;
            track handedOverOption.value
        ) {
            <mat-option
                [value]="handedOverOption.value"
                [disabled]="handedOverOption.disabled"
            >
                {{ handedOverOption.label }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
